import { QueryClient } from '@tanstack/react-query';

const reactQueryClient = new QueryClient();
export { reactQueryClient };
